import { render, staticRenderFns } from "./UpdateContactInfo.vue?vue&type=template&id=3c13e1d3&"
import script from "./UpdateContactInfo.vue?vue&type=script&lang=ts&"
export * from "./UpdateContactInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports